export function News(id, title, content, url, background, deleted, archived) {
    this.id = id;
    this.title = title;
    this.content = content;
    this.url = url;
    this.background = background;
    this.deleted = deleted;
    this.archived = archived;
}

export function Page(id, title, titleInUrl, priority, content, pagePublic) {
    this.id = id;
    this.title = title;
    this.titleInUrl = titleInUrl;
    this.priority = priority;
    this.content = content;
    this.public = pagePublic;
}

export function User(id, memberState, isFreshman, alias, godparent1Id, godparent2Id, roles) {
    this.id = id;
    this.memberState = memberState;
    this.isFreshman = isFreshman;
    this.alias = alias;
    this.godparent1Id = godparent1Id;
    this.godparent2Id = godparent2Id;
    this.roles = roles;
}

export function Event(id, name, venue, date, description, previewPicture, registrationLimit, registrationStartDate,
    registrationDeadline, cost, stein, steinCost, steinOrderDeadline, guestsPerUserLimit, publicParam, organisersPublished, onlyFreshmenCanRegister, deleted) {
    this.id = id;
    this.name = name;
    this.venue = venue;
    this.date = date;
    this.description = description;
    this.previewPicture = previewPicture;
    this.registrationLimit = registrationLimit;
    this.registrationStartDate = registrationStartDate;
    this.registrationDeadline = registrationDeadline;
    this.cost = cost;
    this.stein = stein;
    this.steinCost = steinCost;
    this.steinOrderDeadline = steinOrderDeadline;
    this.guestsPerUserLimit = guestsPerUserLimit;
    this.public = publicParam;
    this.organisersPublished = organisersPublished;
    this.onlyFreshmenCanRegister = onlyFreshmenCanRegister;
    this.deleted = deleted;
}

export function EventRegistration(id, type, state, paidAmount, adminRemark, adminMessage, guestName, guestEmail,
    steinCaption, remark, post, userId, eventId) {
    this.id = id;
    this.type = type;
    this.state = state;
    this.paidAmount = paidAmount;
    this.adminRemark = adminRemark;
    this.adminMessage = adminMessage;
    this.guestName = guestName;
    this.guestEmail = guestEmail;
    this.steinCaption = steinCaption;
    this.remark = remark;
    this.post = post;
    this.userId = userId;
    this.eventId = eventId;
}

export function EventRegistrationUser(id, type, guestName, guestEmail, steinCaption, remark, post, eventId) {
    this.id = id;
    this.type = type;
    this.guestName = guestName;
    this.guestEmail = guestEmail;
    this.steinCaption = steinCaption;
    this.remark = remark;
    this.post = post;
    this.eventId = eventId;
}

export function Task(id, name, description, remark, pointValue, neededPeople, deadline, deleted, state, eventId) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.remark = remark;
    this.pointValue = pointValue;
    this.neededPeople = neededPeople;
    this.deadline = deadline;
    this.deleted = deleted;
    this.state = state;
    this.eventId = eventId;
}
export function TaskRegistration(id, remark, pointValue, state, adminRemark, deleted, taskId, userId){
    this.id = id;
    this.remark = remark;
    this.pointValue = pointValue;
    this.state = state;
    this.adminRemark = adminRemark;
    this.deleted = deleted;
    this.taskId = taskId;
    this.userId = userId;
}

export function PaymentItem(id, name, description, defaultValue, eventId){
    this.id = id;
    this.name = name;
    this.description = description;
    this.defaultValue = defaultValue;
    this.eventId = eventId;
}

export function Payment(id, value, remark, paymentItemId, eventRegId){
    this.id = id;
    this.value = value;
    this.remark = remark;
    this.paymentItemId = paymentItemId;
    this.eventRegistrationId = eventRegId;
}